module.exports = __webpack_public_path__ + "static/media/ntaa-badge-3.069b4cd8.png";